import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { ProveedorAuth } from './auth/ContextoAuth'
import { RutaProtegida } from './auth/RutaProtegida'
import { Layout } from './componentes/Layout'
import { Login } from './paginas/Login'
import { Pos } from './paginas/Pos'
import { Caja } from './paginas/Caja'
import { Productos } from './paginas/Productos'
import { CargaProductos } from './paginas/CargaProductos'
import { Inventario } from './paginas/Inventario'
import { Traspasos } from './paginas/Traspasos'
import { Clientes } from './paginas/Clientes'
import { Reportes } from './paginas/Reportes'
import { Promociones } from './paginas/Promociones'
import { Usuarios } from './paginas/Usuarios'
import { Sucursales } from './paginas/Sucursales'
import { Devoluciones } from './paginas/Devoluciones'
import { Configuracion } from './paginas/Configuracion'
import './paginas/login.css'

export function App() {
    return (
        <BrowserRouter>
            <ProveedorAuth>
                <Routes>
                    <Route path="/entrar" element={<Login />} />

                    <Route
                        element={
                            <RutaProtegida>
                                <Layout />
                            </RutaProtegida>
                        }
                    >
                        <Route index element={<Navigate to="/pos" replace />} />

                        <Route
                            path="/pos"
                            element={
                                <RutaProtegida permiso="venta.crear">
                                    <Pos />
                                </RutaProtegida>
                            }
                        />

                        <Route
                            path="/caja"
                            element={
                                <RutaProtegida permiso="caja.abrir">
                                    <Caja />
                                </RutaProtegida>
                            }
                        />

                        <Route
                            path="/productos"
                            element={
                                <RutaProtegida permiso="catalogo.ver">
                                    <Productos />
                                </RutaProtegida>
                            }
                        />

                        <Route
                            path="/productos/carga"
                            element={
                                <RutaProtegida permiso="catalogo.editar">
                                    <CargaProductos />
                                </RutaProtegida>
                            }
                        />

                        <Route
                            path="/inventario"
                            element={
                                <RutaProtegida permiso="inventario.ver">
                                    <Inventario />
                                </RutaProtegida>
                            }
                        />

                        <Route
                            path="/traspasos"
                            element={
                                <RutaProtegida permiso="inventario.ver">
                                    <Traspasos />
                                </RutaProtegida>
                            }
                        />

                        <Route
                            path="/devoluciones"
                            element={
                                <RutaProtegida permiso="devolucion.registrar">
                                    <Devoluciones />
                                </RutaProtegida>
                            }
                        />

                        <Route
                            path="/clientes"
                            element={
                                <RutaProtegida permiso="credito.ver">
                                    <Clientes />
                                </RutaProtegida>
                            }
                        />

                        <Route
                            path="/reportes"
                            element={
                                <RutaProtegida permiso="reporte.ver">
                                    <Reportes />
                                </RutaProtegida>
                            }
                        />

                        {/* Sin permiso en la ruta: la pantalla es de solo
                            lectura salvo con `configuracion.editar`, y el
                            bloque de respaldos exige `respaldo.ejecutar`. */}
                        <Route path="/configuracion" element={<Configuracion />} />

                        <Route
                            path="/promociones"
                            element={
                                <RutaProtegida permiso="promocion.administrar">
                                    <Promociones />
                                </RutaProtegida>
                            }
                        />

                        <Route
                            path="/usuarios"
                            element={
                                <RutaProtegida permiso="usuario.administrar">
                                    <Usuarios />
                                </RutaProtegida>
                            }
                        />

                        <Route
                            path="/sucursales"
                            element={
                                <RutaProtegida permiso="sucursal.administrar">
                                    <Sucursales />
                                </RutaProtegida>
                            }
                        />
                    </Route>

                    <Route path="*" element={<Navigate to="/pos" replace />} />
                </Routes>
            </ProveedorAuth>
        </BrowserRouter>
    )
}
